import {ENV_NAME} from '@shared/env';

export const MIN_CYCLES_SINCE_LAST_CYCLES_WARNING = (ENV_NAME as string) === 'prod' ? 150000 : 500;
